import React, { ReactElement } from 'react';
import { Popover as AntPopover } from 'antd';

type DropdownTrigger = 'click' | 'hover';
type DropdownPlacement = 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight';

interface DropdownCustomStyles {
  padding?: CSSSize | number;
  borderRadius?: CSSSize | number;
}

interface DropdownProps {
  children: React.ReactNode;
  content: () => React.ReactElement;
  open?: boolean;
  openHandler?: (open: boolean) => void;
  trigger?: DropdownTrigger;
  placement?: DropdownPlacement;
  arrow?: boolean;
  className?: string;
  customStyles?: DropdownCustomStyles;
}

function Dropdown({
  children,
  content,
  open,
  openHandler,
  trigger = 'click',
  placement = 'bottomLeft',
  arrow = false,
  className,
  customStyles,
}: DropdownProps): ReactElement {
  return (
    <AntPopover
      open={open}
      placement={placement}
      arrow={arrow}
      trigger={trigger}
      content={content}
      onOpenChange={openHandler}
      className={className}
      overlayInnerStyle={customStyles}
    >
      {children}
    </AntPopover>
  );
}

export { Dropdown };
